var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBAtSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-at-sign",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-at-sign1",
    serifid: "iconB-at-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.74,15.318c-0.916,1.032 -2.252,1.682 -3.74,1.682c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c1.126,0 2.164,0.372 3,1c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,5c0,0.53 0.211,1.039 0.586,1.414c0.375,0.375 0.884,0.586 1.414,0.586c0.53,0 1.039,-0.211 1.414,-0.586c0.375,-0.375 0.586,-0.884 0.586,-1.414l0,-1c0,-2.031 -0.687,-4.003 -1.95,-5.594c-1.263,-1.591 -3.027,-2.708 -5.005,-3.17c-1.978,-0.462 -4.054,-0.24 -5.89,0.627c-1.837,0.868 -3.326,2.332 -4.225,4.153c-0.899,1.822 -1.156,3.894 -0.728,5.88c0.427,1.985 1.514,3.768 3.084,5.058c1.569,1.289 3.528,2.01 5.559,2.045c2.031,0.035 4.014,-0.618 5.627,-1.853c0.438,-0.336 1.066,-0.252 1.402,0.186c0.336,0.438 0.252,1.066 -0.186,1.402c-1.971,1.509 -4.395,2.308 -6.877,2.265c-2.482,-0.043 -4.877,-0.924 -6.795,-2.5c-1.918,-1.577 -3.247,-3.755 -3.769,-6.182c-0.523,-2.427 -0.209,-4.96 0.89,-7.186c1.099,-2.226 2.918,-4.015 5.163,-5.076c2.245,-1.061 4.782,-1.331 7.2,-0.767c2.418,0.565 4.573,1.93 6.117,3.875c1.543,1.945 2.383,4.354 2.383,6.837l0,1c0,1.061 -0.421,2.078 -1.172,2.828c-0.75,0.751 -1.767,1.172 -2.828,1.172c-1.061,-0 -2.078,-0.421 -2.828,-1.172c-0.159,-0.158 -0.303,-0.329 -0.432,-0.51Zm-0.74,-3.318c-0,-1.657 -1.343,-3 -3,-3c-1.657,0 -3,1.343 -3,3c-0,1.657 1.343,3 3,3c1.657,0 3,-1.343 3,-3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBAtSign);
export default __webpack_public_path__ + "static/media/iconB-at-sign.21e5314a5534e09c48801a6a150a080d.svg";
export { ForwardRef as ReactComponent };